<template>
<div>
  <div class="row">
    <div class="col-12">
      <h1>Signature - {{ survey.clientFirstName }} {{ survey.clientLastName }}</h1>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="qm-panel">
        <h2>Legal notes</h2>
        <form v-if="legalNotesLoaded">
          <div class="form-group row">
            <div class="col-12">
              <label class="col-form-label" for="qm-survey-legal-notes">Choose language:</label>
              <select v-model="selectedLanguage" v-on:change="showLegalNote" class="custom-select" name="qm-survey-legal-notes" id="qm-survey-legal-notes">
                <option v-for="legalNote in legalNotes" v-bind:value="legalNote['language-code']">{{ legalNote['language-code'] }}</option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <textarea class="form-control" disabled="disabled">{{ legalNoteText }}</textarea>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="qm-panel">
        <h2>Signature</h2>
        <form>
          <div class="form-group row">
            <div class="col-12">
              <label for="clientName" class="col-form-label">Client name</label>
              <input id="clientName" v-model="clientName" type="text" class="form-control">
            </div>

          </div>
        </form>
        <label for="signature" class="col-form-label">Sign here:</label>
        <canvas id="signature" class="form-control"></canvas>
        <div class="qm-survey-button-row">
          <button v-on:click="clearSignaturePad" type="button" class="btn btn-warning btn-sm qm-survey-edit-button ripple">
            <i class="fa fa-eraser"></i>
            Clear signature pad
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="qm-survey-button-row">
    <button v-on:click="saveSignature" type="button" class="btn btn-turquois qm-survey-edit-button"><i class="fa fa-floppy-o"></i> Save signature</button>
    <button v-on:click="deleteSignature" type="button" class="btn btn-danger qm-survey-edit-button"><i class="fa fa-times"></i> Delete signature</button>
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
// https://github.com/szimek/signature_pad
import SignaturePad from 'signature_pad'
export default {
  name: 'SurveySignature',
  data: () => ({
    canvas: {},
    clientName: '',
    signaturePad: {},
    signatureDataUrl: '',
    selectedLanguage: '',
    legalNotes: [],
    legalNotesLoaded: false
  }),
  computed: {
    surveyStorageKey () {
      return 'survey-' + this.session.surveyId
    },
    ...mapGetters({
      session: 'getSession',
      survey: 'getSurvey'
    }),
    legalNoteText () {
      var legalNoteText = ''
      if (this.legalNotes.length > 0) {
        var currentLegalNote = this.legalNotes.filter((legalNote) => {
          return legalNote['language-code'] === this.selectedLanguage
        })
        if (currentLegalNote.length > 0) {
          legalNoteText = currentLegalNote[0].value
        } else {
          legalNoteText = this.legalNotes[0].value
          this.selectedLanguage = this.legalNotes[0]['language-code']
        }
      }
      return legalNoteText
    }
  },
  created: function () {
    // set language options from config
    let languageOptions = this.$getLanguages()
    this.selectedLanguage = languageOptions[0]
    this.$store.dispatch('loadSession').then(() => {
      this.$store.dispatch('loadAllLegalNotes').then(() => {
        this.$store.dispatch('getSurveyById', this.session.surveyId).then(() => {
          if (this.survey.clientLanguage !== null) {
            this.selectedLanguage = this.survey.clientLanguage
          }
          this.legalNotes = this.$store.getters.getAllLegalNotes
          this.legalNotesLoaded = true
          this.signatureDataUrl = this.survey.signatureDataUrl
          this.signaturePad.fromDataURL(this.survey.signatureDataUrl)
          this.clientName = this.survey.signatureName
        })
      })
    })
  },
  mounted: function () {
    this.canvas = document.querySelector('#signature')
    this.signaturePad = new SignaturePad(
      this.canvas,
      {
        minWidth: 3,
        maxWidth: 6,
        penColor: 'rgb(53, 123, 134)'
      }
    )
    window.addEventListener('load, resize', this.signaturePadResizeCanvas)
    this.signaturePadResizeCanvas()
  },
  methods: {
    saveSignature () {
      if (this.signaturePad._isEmpty !== true) {
        this.survey.signatureName = this.clientName
        this.survey.signatureDataUrl = this.signaturePad.toDataURL()
        this.survey.signed = true
        this.$store.dispatch('updateSurvey', this.survey).then(() => {
          this.$router.replace({name: 'survey'})
        })
      } else {
        this.deleteSignature()
      }
    },
    deleteSignature () {
      this.survey.signatureDataUrl = ''
      this.survey.signed = false
      this.$store.dispatch('updateSurvey', this.survey).then(() => {
        this.clearSignaturePad()
        this.signatureDataUrl = ''
        this.$router.replace({name: 'survey'})
      })
    },
    clearSignaturePad () {
      this.signaturePad.clear()
      this.signatureDataUrl = ''
    },
    signaturePadResizeCanvas () {
      // https://github.com/szimek/signature_pad#tips-and-tricks
      var ratio = Math.max(window.devicePixelRatio || 1, 1)
      this.canvas.width = this.canvas.offsetWidth * ratio
      this.canvas.height = this.canvas.offsetHeight * ratio
      this.canvas.getContext('2d').scale(ratio, ratio)
      this.signaturePad.clear() // otherwise isEmpty() might return incorrect value
    },
    showLegalNote () {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SurveySignature.vue